import IResult from 'src/dataModel/IResult';
import IReq from './IReq';
import IResp from './IResp';
import Urls from 'src/config/Urls';
import http from 'src/utils/ajaxUtils';

/**
 * 接口描述
 * @param param 参数，IReq类型
 */
async function postIpsSplit2(param: IReq): Promise<IResult<IResp>> {
  const resp = await http.post(Urls.postIpsSplit2, param);
  return resp;
}

export default postIpsSplit2;


// WEBPACK FOOTER //
// ./src/api/IPManage/postIpsSplit2/index.ts